export default __webpack_public_path__ + "static/media/edit-button.6be5f8e1.svg";